import ActionIconButton from "./shared/ActionIconButton";

function EditComplexButton({ onClick, disabled = false, label = "Редактировать ЖК" }) {
  return (
    <ActionIconButton
      icon="edit"
      label={label}
      title={false}
      tone="primary"
      className="edit-complex-button"
      data-tooltip={label}
      disabled={disabled}
      onClick={onClick}
    />
  );
}

export default EditComplexButton;
